export default __webpack_public_path__ + "static/media/skyground-light.5013db1e.svg";